// src/pages/profesionales/ProfesionalesPendientes.js
import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import InputGroup from 'react-bootstrap/InputGroup'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Alert from 'react-bootstrap/Alert'
import { toast } from 'react-toastify'
import Paginacion from 'components/Paginacion'
import api from 'api/api'

import './profesionales.css'
import { DEFAULT_FETCH_CUANTOS, NO_AVATAR_IMAGE_URL } from 'utils/constants'
import { debounce } from 'utils/debounce'
import VerProfesional from './VerProfesional'
import AprobarProfesional from './AprobarProfesional'
import RechazarProfesional from './RechazarProfesional'
import { toDisplayDate } from 'utils/date'

function ProfesionalesPendientes() {
	const [fetchDeACuantos, setFetchDeACuantos] = useState(DEFAULT_FETCH_CUANTOS)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	const [busqueda, setBusqueda] = useState('')
	const [filtroBusqueda, setFiltroBusqueda] = useState('')
	const [profesionales, setProfesionales] = useState([])
	const [profesionalActual, setProfesionalActual] = useState()
	const [queMostrar, setQueMostrar] = useState('')

	const opcionesCuantosMostrar = [10, 25, 50]

	const refreshProfesionales = async () => {
		try {
			setLoading(true)
			const { datos, error } = await api.post('a/ver-profesionales', {
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					estado: 'pendiente',
					usuario: [filtroBusqueda],
					nombre: [filtroBusqueda],
					apellido: [filtroBusqueda],
					ci: [filtroBusqueda],
					telefono: [filtroBusqueda]
				}
			})

			if (error) {
				toast.error('Error al cargar profesionales: ' + error)
				return
			}

			setProfesionales(datos.profesionales || [])
			setNumResultados(datos.numResultados || 0)
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const handleBusqueda = (value) => {
		if (value) {
			setFiltroBusqueda(value)
		} else {
			setFiltroBusqueda('')
		}
	}

	const debouceFiltroBusqueda = React.useCallback(
		debounce(handleBusqueda, 400),
		[]
	)

	useEffect(() => {
		debouceFiltroBusqueda(busqueda)
	}, [busqueda])

	useEffect(() => {
		if (paginaAct === 1) {
			refreshProfesionales()
		} else {
			setPaginaAct(1)
		}
	}, [filtroBusqueda, fetchDeACuantos])

	useEffect(() => {
		if (!loading) {
			refreshProfesionales()
		}
	}, [paginaAct])

	const handleAction = (profesional, cual) => {
		setProfesionalActual(profesional)
		setQueMostrar(cual)
	}

	const aprobarProfesional = async (id) => {
		try {
			setLoading(true)
			const { msg, error } = await api.post(`a/profesionales/${id}/aprobar`)

			if (error) {
				toast.error('Error al aprobar profesional: ' + error)
				return
			}

			refreshProfesionales()
			setQueMostrar('')
			toast.success(msg || 'Profesional aprobado correctamente')
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const rechazarProfesional = async (id, mensaje) => {
		try {
			setLoading(true)
			const { msg, error } = await api.post(`a/profesionales/${id}/rechazar`, { mensaje })

			if (error) {
				toast.error('Error al rechazar profesional: ' + error)
				return
			}

			refreshProfesionales()
			setQueMostrar('')
			toast.success(msg || 'Profesional rechazado correctamente')
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		refreshProfesionales()
	}, [])

	return (
		<Container fluid id="profesionales" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col xs={12} className="mt-2">
					<h1>Profesionales Pendientes</h1>
					<hr />
				</Col>
			</Row>
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Form>
						<Row id="searchbar" className="justify-content-between align-items-center">
							<Col sm={6} md={3} style={{ display: 'block' }}>
								<small>
									<span className="d-none d-sm-inline-block">Mostrar de a</span>
									<Form.Group style={{ display: 'inline-block' }}>
										<Form.Select size="sm" onChange={(e) => setFetchDeACuantos(e.target.value)} className="mx-1">
											{opcionesCuantosMostrar.map((o) => (
												<option value={o} key={`mostrar-${o}`}>{o}</option>
											))}
										</Form.Select>
									</Form.Group>
									<span className="ms-2">resultados</span>
								</small>
							</Col>
							<Col md={5} lg={4}>
								<Form.Group controlId="txtBusqueda">
									<InputGroup>
										<Form.Control
											autoFocus
											value={busqueda}
											onChange={(e) => setBusqueda(e.target.value)}
											type="text"
											placeholder="Buscar profesional..."
											aria-label="Buscar"
										/>
										<InputGroup.Text><i className="fa fa-search"></i></InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Col>
			</Row>

			{/* Lista de profesionales */}
			<Row>
				<Col sm={12}>
					{loading ? (
						<div className="text-center my-5">
							<Spinner
								animation="border"
								size="lg"
								role="status"
								aria-hidden="true"
								variant="primary"
							/>
							<p className="mt-2">Cargando profesionales...</p>
						</div>
					) : profesionales.length === 0 ? (
						<Alert variant="info" className="my-4">
							No se encontraron profesionales pendientes de aprobación
						</Alert>
					) : (
						<Table id="table-profesionales" className="table table-striped">
							<thead>
								<tr>
									<th>ID</th>
									<th>Avatar</th>
									<th>Solicitud</th>
									<th>Usuario</th>
									<th>Apellido</th>
									<th>Nombre</th>
									<th>Servicios</th>
									<th>Acciones</th>
								</tr>
							</thead>
							<tbody>
								{profesionales.map((profesional) => {
									console.log('profesional', profesional)
									return (
										<tr key={profesional.id}>
											<td>{profesional.id}</td>
											<td>
												<img
													className="list-avatar"
													src={profesional.avatar ? (process.env.REACT_APP_API_URL + profesional.avatar.url) : NO_AVATAR_IMAGE_URL}
													alt={`Avatar de ${profesional.nombre}`}
												/>
											</td>
											<td>{toDisplayDate(profesional.fechaSolicitud)}</td>
											<td>{profesional.email}</td>
											<td>{profesional.apellido}</td>
											<td>{profesional.nombre}</td>
											<td>
												{profesional.servicios && profesional.servicios.length > 0 ? (
													<span className="badge bg-primary">{profesional.servicios.length}</span>
												) : (
													<span className="badge bg-secondary">0</span>
												)}
											</td>
											<td>
												<DropdownButton
													as={ButtonGroup}
													title={<i className="fa fa-ellipsis-v"></i>}
													drop="end"
												>
													<Dropdown.Item
														onClick={() => handleAction(profesional, 'ver')}
													>
														<i className="fa fa-eye me-2"></i> Ver
													</Dropdown.Item>
													<Dropdown.Item
														onClick={() => handleAction(profesional, 'aprobar')}
													>
														<i className="fa fa-check me-2 text-success"></i> Aprobar
													</Dropdown.Item>
													<Dropdown.Item
														onClick={() => handleAction(profesional, 'rechazar')}
														className="text-danger"
													>
														<i className="fa fa-times me-2"></i> Rechazar
													</Dropdown.Item>
												</DropdownButton>
											</td>
										</tr>
									)
								})}
							</tbody>
						</Table>
					)}
					<Col>
						<Paginacion
							numResultados={numResultados}
							pagina={paginaAct}
							setPagina={setPaginaAct}
							deACuantos={fetchDeACuantos}
						/>
					</Col>
				</Col>
			</Row>

			{/* Panel Ver */}
			{profesionalActual && queMostrar === 'ver' && (
				<VerProfesional
					profesionalId={profesionalActual.id}
					setQueMostrar={setQueMostrar}
				/>
			)}

			{/* Modal aprobar */}
			{profesionalActual && queMostrar === 'aprobar' && (
				<AprobarProfesional
					key={profesionalActual.id}
					profesional={profesionalActual}
					setQueMostrar={setQueMostrar}
					aprobar={aprobarProfesional}
				/>
			)}

			{/* Modal rechazar */}
			{profesionalActual && queMostrar === 'rechazar' && (
				<RechazarProfesional
					key={profesionalActual.id}
					profesional={profesionalActual}
					setQueMostrar={setQueMostrar}
					rechazar={rechazarProfesional}
				/>
			)}
		</Container>
	)
}

export default ProfesionalesPendientes